// removed by extract-text-webpack-plugin
module.exports = {"dark-purple":"#4a2e5e","inlineLayout":"zhjkGoUm6LWXSef7kQBg","actionLayout":"_29lMSCWfFaUjmTAjVBtnMA"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/components/Notification/constants/notificationsLayouts.css
// module id = 1309
// module chunks = 0